<!-- <div class="alert alert-danger" *ngIf="errMsg"><i class="bi bi-exclamation-triangle me-2"></i>{{ errMsg }}</div>
<div class="alert alert-success" *ngIf="okMsg"><i class="bi bi-check-circle me-2"></i>{{ okMsg }}</div> -->

<form #fuForm="ngForm" novalidate>
  <div class="mb-3">
    <label class="form-label req">Enquiry</label>
    <select class="form-select" name="enquiryNo" [(ngModel)]="frmData.inq_id" required #fuEnq="ngModel"
      [class.is-invalid]="fuEnq.invalid && fuEnq.touched">
      <option value="">-- Select Enquiry --</option>
      <option *ngFor="let e of enquiries" [value]="e.id">
        {{ e.code }} — {{ e.name }} {{e.gender=='M' ? 'S/o' : 'D/o'}} {{e.father}}
      </option>
    </select>
    <div class="invalid-feedback">Select an enquiry</div>
  </div>

  <div class="mb-3">
    <label class="form-label req">Mode</label>
    <select class="form-select" name="fuMode" [(ngModel)]="frmData.fup_mode" required #fuMode="ngModel"
      [class.is-invalid]="fuMode.invalid && fuMode.touched">
      <option value="">-- Select Mode --</option>
      <option *ngFor="let m of followUpModes" [value]="m.code">{{ m.name }}</option>
    </select>
    <div class="invalid-feedback">Required</div>
  </div>

  <div class="mb-3">
    <label class="form-label req">Discussion Notes</label>
    <textarea class="form-control" name="fuNotes" rows="5" [(ngModel)]="frmData.fup_notes" required
      placeholder="Summary of conversation…" #fuNotes="ngModel"
      [class.is-invalid]="fuNotes.invalid && fuNotes.touched"></textarea>
    <div class="invalid-feedback">Required</div>
  </div>

  <div class="d-flex justify-content-between mb-3">
    <div class="col-6">
      <label class="form-label req">Lead Status</label>
      <select class="form-select" name="fuStatus" [(ngModel)]="frmData.lead_status" required #fuStatus="ngModel"
        [class.is-invalid]="fuStatus.invalid && fuStatus.touched">
        <option value="">-- Select Status --</option>
        <option *ngFor="let s of leadStatuses" [value]="s.code">{{ s.name }}</option>
      </select>
      <div class="invalid-feedback">Required</div>
    </div>
    <div class="col-5">
      <label class="form-label req">Next Follow-Up Date</label>
      <input type="date" class="form-control" name="next_date" [(ngModel)]="frmData.next_date">
    </div>
  </div>

  <div class="row g-3 mb-3" *ngIf="user.user_name=='sa'">
    <div class="col-6">
      <label class="form-label">Done By</label>
      <select class="form-select" name="doneBy" [(ngModel)]="frmData.fup_uid">
        <option value="">-- Select --</option>
        <option *ngFor="let c of counsellors" [value]="c.id">{{ c.name }}</option>
      </select>
    </div>
  </div>

  <div class="w-100 d-flex justify-content-center gap-2 my-2">
    <button type="button" class="btn btn-secondary">
      <i class="bi bi-arrow-counterclockwise me-1"></i>Reset
    </button>
    <button type="button" class="btn btn-primary" (click)="isEdit ? doUpdate() : doSave()">
      <i class="bi bi-save me-1"></i>{{ isEdit ? 'Update' : 'Save Follow-Up' }}
    </button>
    <button type="button" class="btn btn-warning">
      <i class="bi bi-person-square"></i> Assign to
    </button>
  </div>
</form>
